<template>
  <div class="result">
    <div v-if="results == 'true'">
      <img src="../assets/resultTrue.png" alt="" class="top" />
      <img
        src="../assets/resultTBtn.png"
        alt=""
        class="bottom"
        @click="toDraw()"
      />
    </div>
    <div v-if="results != 'true'">
      <img src="../assets/resultFalse.png" alt="" class="top" />
      <img
        src="../assets/resultFBtn.png"
        alt=""
        class="bottom"
        @click="toAnswer()"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "result",
  data() {
    return {
      paper: [],
      results: null,
    };
  },
  mounted() {
    this.results = this.$route.query.result;
    this.paper = this.$route.query.paper;
    console.log(this.results);
    console.log(this.paper);
  },
  methods: {
    toAnswer() {
      this.$router.push({
        path: "/answer",
      });
    },
    toDraw() {
      this.$router.push({
        path: "/luckDraw",
        query: {
          paper: this.paper,
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.result {
  width: 100vw;
  height: 100%;
  position: relative;
  .top {
    width: 90vw;
    display: block;
    margin: 10vh auto;
  }
  .bottom {
    width: 50vw;
    margin: 0 auto;
    display: block;
  }
}
</style> 



// WEBPACK FOOTER //
// src/pages/result.vue